import { useState, forwardRef, memo } from "react";
import { use as useSet } from "common/src/data/TftSet.bs";
import { usePath4 as useBasePath4 } from "common/src/atoms/CdnAtom.bs";
import { getSrcSet2 } from "./ImgCore";
import { useT2 } from "../bindings/Translation.bs";

const dir = (set: number) => {
  if (set === 90 || set === 95) {
    return "items_s95";
  } else if ((set >= 14 && set < 20) || set === 76 || set >= 140) {
    return "items_s14";
  } else {
    return "items_s10";
  }
};

const getSrc = (basePath: string, set: number, itemId: string) => {
  return `${basePath}/${dir(set)}/${itemId.replace(
    /TFT(.*?)_(Item|Consumable)_(.+)/,
    "$1$3",
  )}.png`;
};

type Props = {
  itemId: string;
  size: number;
  sizeSm?: number;
  sizeMd?: number;
  sizeLg?: number;
  className?: string;
  rounded?: string;
};

const ItemImage = memo(
  forwardRef(
    (
      {
        itemId,
        size,
        sizeSm,
        sizeMd,
        sizeLg,
        className = "",
        rounded = "",
        ...rest
      }: Props,
      ref,
    ) => {
      const [usePlaceholder, setUsePlaceholder] = useState(false);
      const itemsT = useT2("items");
      const set = useSet();
      const bp4 = useBasePath4();
      const basePath = bp4;

      const src = getSrc(basePath, set, usePlaceholder ? "_" : itemId);
      const [sizes, srcSet, sizeClass] = getSrcSet2(
        src,
        size,
        sizeSm,
        sizeMd,
        sizeLg,
      );
      return (
        <img
          loading="lazy"
          decoding="async"
          alt={itemsT(itemId)}
          src={src + `?w=${size}`}
          className={`aspect-square ${className} ${rounded} ${sizeClass}`}
          // @ts-ignore
          ref={ref}
          sizes={sizes}
          srcSet={srcSet}
          {...rest}
          onError={(_) => setUsePlaceholder(true)}
        />
      );
    },
  ),
);

export default ItemImage;
